import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { KomitentTelefon } from './komitent-telefon';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-telefon-update',
  templateUrl: './komitent-telefon-update.component.html'
})
export class KomitentTelefonUpdateComponent extends BaseUpdateComponent<KomitentTelefon> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Broj", Validators.required, 'required', 'KOMITENTTELEFON.BROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("Broj", Validators.maxLength(50), 'maxlength', 'KOMITENTTELEFON.BROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Lokal", Validators.maxLength(4), 'maxlength', 'KOMITENTTELEFON.LOKAL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'KOMITENTTELEFON.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'KOMITENTTELEFON.SVOJINA.VALIDATION.REQUIRED');
    this.addValidatorToFc("VrstaTelefonaID", Validators.required, 'required', 'KOMITENTTELEFON.VRSTATELEFONA.VALIDATION.REQUIRED');
  }

}
